import { createRequestTypes } from 'common/websocket-redux';

export const GET_GROUP = createRequestTypes('site/GET_GROUP');
export const GET_GROUP_BY_ID = createRequestTypes('site/GET_GROUP_BY_ID');

export const getGroupById = groupId => GET_GROUP_BY_ID.request({ groupId });
